module.exports = __webpack_public_path__ + "media/images/app/products/index/occassions/everyday-6221f9938c719d5718051a032e887faa.webp";